import { combineEpics } from 'redux-observable';
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { errorHandler, retryExponentialBackoff } from '../../../lib/api';
import { leaveValidation } from '../ui/actions';
import { isActionOf, makeEpic } from '../utils';
import { fetchSchema, fetchSchemaFulfilled } from './actions';
import { flattenSchema } from './helpers';
import { SchemaBeforeFlattening } from './types';

const fetchSchemaEpic = makeEpic((action$, _state$, { authGetJSON$ }) =>
  action$.pipe(
    filter(isActionOf(fetchSchema)),
    mergeMap(({ meta: { schemaUrl } }) =>
      authGetJSON$<SchemaBeforeFlattening>(`${schemaUrl}`).pipe(
        retryExponentialBackoff(),
        takeUntil(action$.pipe(filter(isActionOf(leaveValidation)))),
        map(flattenSchema),
        map(fetchSchemaFulfilled),
        catchError(errorHandler)
      )
    )
  )
);

export default combineEpics(fetchSchemaEpic);
